import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { getEmbeddedResource } from '@ngxp/rest';
import { StateResource } from '@schir-int-client/ngrx-helpers';
import { sameUri } from '@schir-int-client/tech';
import { isNil, isNull } from 'lodash-es';
import { AufgabeListLinkRel } from './aufgabe.linkrel';
import { AdressatWithResource, AufgabeResource } from './aufgabe.model';
import { aufgabeFeatureState, AufgabeRootState } from './aufgabe.state';
// barrel-import würde Zyklus schließen:
import type { VorlageResource } from 'libs/vorlage-shared/src/lib/vorlage.model';

export const selectFeature = createFeatureSelector<AufgabeRootState>(aufgabeFeatureState);

export const aufgabenSelector: MemoizedSelector<object, StateResource<AufgabeResource[]>> = createSelector(
	selectFeature,
	(state: AufgabeRootState) => {
		const aufgaben = state.aufgabeRoot.aufgaben;
		const resultAufgaben = isNull(aufgaben.resource)
			? []
			: <AufgabeResource[]>getEmbeddedResource(aufgaben.resource, AufgabeListLinkRel.AUFGABE_LIST);
		return { ...aufgaben, resource: resultAufgaben };
	}
);

export function adressatenByAufgabeSelector(aufgabeUri: string): MemoizedSelector<object, AdressatWithResource[]> {
	return createSelector(selectFeature, (state: AufgabeRootState) => {
		return state.aufgabeRoot.adressatenByAufgabe?.[aufgabeUri] ?? null;
	});
}

export function vorlageByUriSelector(vorlageUri: string): MemoizedSelector<object, VorlageResource> {
	return createSelector(selectFeature, (state: AufgabeRootState) => {
		return state.aufgabeRoot.vorlagenResourcesByUri?.[vorlageUri] ?? null;
	});
}

export const aufgabeSelector: MemoizedSelector<object, AufgabeResource> = createSelector(
	selectFeature,
	(state: AufgabeRootState) => {
		return isNil(state?.aufgabeRoot.selectedAufgabe) ? null : state.aufgabeRoot.selectedAufgabe;
	}
);

export function isAufgabeSelectedSelector(aufgabe: AufgabeResource): MemoizedSelector<object, boolean> {
	return createSelector(selectFeature, (state: AufgabeRootState) => {
		return !isNil(state.aufgabeRoot.selectedAufgabe) && sameUri(state.aufgabeRoot.selectedAufgabe, aufgabe);
	});
}
